import {computed, DestroyRef, inject, Injectable, InjectionToken} from '@angular/core';
import {environment} from '../../../environments/environment';
import {AuthService} from '../api-services/auth.service';
import {DashboardPreviewService} from './dashboard-preview.service';
import {AdminPanelConfig, mayEnterAdmin, openAdminSessionBridge} from './admin-session-bridge';

export const ADMIN_PANEL_CONFIG = new InjectionToken<AdminPanelConfig | null>('ADMIN_PANEL_CONFIG', {
  providedIn: 'root', factory: () => environment.adminPanel,
});
export const ADMIN_SESSION_WINDOW = new InjectionToken<Window>('ADMIN_SESSION_WINDOW', {
  providedIn: 'root', factory: () => window,
});

@Injectable({providedIn: 'root'})
export class AdminSessionService {
  private readonly auth = inject(AuthService);
  private readonly preview = inject(DashboardPreviewService);
  private readonly host = inject(ADMIN_SESSION_WINDOW);
  private readonly config = inject(ADMIN_PANEL_CONFIG);
  private stop: () => void = () => {};
  readonly allowed = computed(() => this.config !== null
    && this.host.location.origin === this.config.crmOrigin && !this.preview.active()
    && this.auth.permissionsReady() && mayEnterAdmin(this.auth.permissions()));

  constructor() { inject(DestroyRef).onDestroy(() => this.stop()); }

  open(): void {
    if (!this.allowed() || !this.config) return;
    this.stop();
    this.stop = openAdminSessionBridge(this.host, this.config, () => this.auth.getAuthToken(),
      () => this.allowed(), message => this.host.alert(message));
  }
}
